// export function getBoundsFromRadius(center, radius) {
//   const latChange = radius / 111.32;
//   const lngChange = radius / (111.32 * Math.cos(center.lat * (Math.PI / 180)));

//   return {
//     north: center.lat + latChange,
//     south: center.lat - latChange,
//     east: center.lng + lngChange,
//     west: center.lng - lngChange,
//   };
// }

// const geofenceCenter = { lat: -33.8688, lng: 151.2093 }; // Replace with your geofence center
// const radius = 5; // 5 km radius

// // Calculate bounds based on radius
// const bounds = getBoundsFromRadius(geofenceCenter, radius);

// Utility function to generate a consistent random color based on user ID
const colorPalette = [
  '#F44336', // hueRed
  '#2196F3', // hueBlue
  '#4CAF50', // hueGreen
  '#FF9800', // hueOrange
  '#FFEB3B', // hueYellow
  '#9C27B0', // hueViolet
  '#00BCD4', // hueCyan
  '#03A9F4', // hueAzure
  '#E91E63', // hueMagenta
  '#F06292', // hueRose
];

export const getColorFromId = (id) => {
  const hash = id.split('').reduce((acc, char) => {
    return (acc << 5) - acc + char.charCodeAt(0);
  }, 0);
  return colorPalette[Math.abs(hash) % colorPalette.length];
};

export const getInitials = (firstName, lastName) => {
  const first = firstName?.charAt(0)?.toUpperCase() || '';
  const last = lastName?.charAt(0)?.toUpperCase() || '';
  return `${first}${last}`;
};

export function getBoundsFromRadius(center, radiusKm) {
  const lat = Number(center.lat);
  const lng = Number(center.lng);
  const radius = Number(radiusKm);

  // Approximate kilometers per degree of latitude
  const kmPerDegreeLatitude = 111.32;

  const latChange = radius / kmPerDegreeLatitude;

  const lngChange = radius / (kmPerDegreeLatitude * Math.cos((lat * Math.PI) / 180));

  return {
    north: lat + latChange,
    south: lat - latChange,
    east: lng + lngChange,
    west: lng - lngChange,
  };
}

export const isValidPremiseRange = (range) => {
  const n = Number(range);
  return Number.isFinite(n) && n > 0;
};
